"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isDefined(value) {
  return value !== undefined && value !== null;
}

exports.isDefined = isDefined;

exports.anyDefined = function () {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.filter(isDefined).length > 0;
};

exports.allDefined = function () {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var result = args.filter(isDefined);
  return !!(args.length && result.length === args.length);
};

exports.allPropsDefined = function (props) {
  if (props === void 0) {
    props = {};
  }

  return exports.allDefined.apply(void 0, Object.values(props));
};

function typeOf(value, type) {
  return isDefined(value) && typeof value === type;
}

exports.typeOf = typeOf;

function isArray(value) {
  return Array.isArray(value);
}

exports.isArray = isArray;

function isBool(value) {
  return typeOf(value, 'boolean');
}

exports.isBool = isBool;

function isBoolean(value) {
  return isBool(value);
}

exports.isBoolean = isBoolean;

function isFunction(value) {
  return typeOf(value, 'function');
}

exports.isFunction = isFunction;

function isNumber(value) {
  return typeOf(value, 'number');
}

exports.isNumber = isNumber;

function isString(value) {
  return typeOf(value, 'string');
}

exports.isString = isString;

function isObject(value) {
  return typeOf(value, 'object') && !isFunction(value) && !isArray(value);
}

exports.isObject = isObject;

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

exports.isPlainObject = isPlainObject;